module.exports = __webpack_public_path__ + "img/popup_new_user_head_long.188796ec.png";